import { fetchV3WithTranslateServerErrors } from './base';
import { _validateTaxIdCountry } from './constants';
import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';

const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

export const validateTaxId = (eventId, country, taxId) =>
    fetchV3WithTranslateServerErrors(
        ERROR_SPEC,
        _validateTaxIdCountry(eventId, country, taxId),
        {
            method: 'GET',
        },
    );
